export const lightButtonStyle =
  'txt-btn text-base text-white bg-adv-blue-100 py-3 px-7 tracking-[0.21em] disabled:bg-adv-blue-100/25';
export const darkButtonStyle = 'txt-btn text-base text-white bg-adv-blue-800 py-3 px-7 tracking-[0.21em]';
export const formInput = 'border border-solid border-dark-grey rounded-lg h-10 w-full p-2 placeholder:p-2';
